module.exports = __webpack_public_path__ + "img/ic_marker_asset_cluster_multiple.213b2b08.png";